import AppDispatcher from "../Dispatcher";
import EventEmitter from "events";
import { AppActionConstants } from "../Actions/AppActionConstants";
// import BookFiltersStore from '../Stores/BookFiltersStore';
import _ from "lodash";
import { getUpdatedCampaignDataPostPush } from "../../Helpers/PlatformHelpers";

class CampaignsStore extends EventEmitter {
	constructor() {
		super();

		this.campaignGrid = {
			data: [],
			config: [],
			mediaChannels: [],
			platforms: [],
			activationConfig: [],
			errors: {
				campaign: [],
				activation: []
			},
			advertisers: [],
			advertiserFields: {},
			newCampaign: null,
			advertiserErrors: {},
			advertiserSuccess: [],
			editAdvertiserSuccessObj: {},
			platformAdvertisers: [],
			dataKeyDataValueFilters: null,
			targetMasterCampaignID: null,
			selectedCampaigns: {},
			clonedActivationCampaign: null,
			previousActivationCampaignIDs: [],
			pushedCampaign: null,
			newlyCreatedActivationCampaign: null,
			gcmSuccess: false
		};

		/*
		Need to register all actions with the AppDispatcher
		*/

		AppDispatcher.register((action) => {
			switch (action.type) {
				/*
				Action responsible for the initial data fetch
				*/
				case AppActionConstants.fetchCampaigns:
					if (action.value.config) {
						this.campaignGrid.config = action.value.config;
					}

					if (action.value.data) {
						this.campaignGrid.data = action.value.data.sort((a, b) => {
							if (a.IsArchived === true && b.IsArchived === false) {
								return 1;
							}
							if (a.IsArchived === false && b.IsArchived === true) {
								return -1;
							}
							return 0;
						});
					}

					if (action.value.mediaChannelPlatforms) {
						this.campaignGrid.mediaChannelPlatforms = action.value.mediaChannelPlatforms.filter((platform) => {
							return platform.HierarchyLevelName === "Campaign";
						});
						this.campaignGrid.mediaChannelPlatforms.forEach((platform) => {
							platform.label = platform.PlatformName;
							platform.value = platform.MasterPlatformID;
						});
						this.campaignGrid.advertisers = action.value.mediaChannelPlatforms.filter((platform) => {
							return platform.HierarchyLevelName === "Advertiser";
						});
					}
					this.emit("campaignfetch");
					break;
				case AppActionConstants.fetchConfigAndPlatforms:
					if (action.value.config) {
						this.campaignGrid.config = action.value.config;
					}

					if (action.value.mediaChannelPlatforms) {
						this.campaignGrid.mediaChannelPlatforms = action.value.mediaChannelPlatforms.filter((platform) => {
							return platform.HierarchyLevelName === "Campaign";
						});
						this.campaignGrid.mediaChannelPlatforms.forEach((platform) => {
							platform.label = platform.PlatformName;
							platform.value = platform.MasterPlatformID;
						});
						this.campaignGrid.advertisers = action.value.mediaChannelPlatforms.filter((platform) => {
							return platform.HierarchyLevelName === "Advertiser";
						});
					}

					this.emit("fetchConfigAndPlatforms");
					break;
				case AppActionConstants.fetchActivationHeaders:
					this.campaignGrid.activationConfig = action.value;
					this.emit("activationConfig");
					break;
				case AppActionConstants.holdMasterCampaignUniqueID:
					this.campaignGrid.selectedMasterCampaignUniqueID = action.value;
					break;
				case AppActionConstants.putCampaignUniqueID:
					this.campaignGrid.selectedParentCampaignUniqueID = action.value;
					this.emit("campaignID_updated");
					break;
				case AppActionConstants.updateActivationDataSuccess: {
					const updateActivationSuccess = async () => {
						let platforms;
						const campaignData = this.campaignGrid.data;
						const result = campaignData.filter((lineItem) => {
							if (lineItem.MasterCampaignUniqueIDCode === parseInt(action.value.MasterCampaignID, 10)) {
								platforms = lineItem.AvailableActivations;
								return lineItem;
							}
						});

						/* Update ParentUniqueID for Workbook */
						this.campaignGrid.selectedParentCampaignUniqueID = action.value.CampaignID;

						this.campaignGrid.selectedMasterCampaignUniqueID = action.value.MasterCampaignID;

						const platform = platforms.filter((lineItem) => {
							if (Number(lineItem.MasterPlatformID.toString()) === Number(action.value.MasterPlatformID)) {
								return lineItem;
							}
						});
						const platformName = platform[0].PlatformName;
						const parentArray = result[0].ActivationCampaigns[platformName];
						parentArray.push(action.value);
						this.campaignGrid.newlyCreatedActivationCampaign = action.value;
						await this.kickOffEvent();
					};
					this.campaignGrid.newlyCreatedActivationCampaign = action.value;
					this.kickOffEvent();
					// updateActivationSuccess();
					break;
				}
				case AppActionConstants.updateActivationDataFail:
					this.campaignGrid.errors.activation = action.value;
					this.emit("error_activation");
					break;
				case AppActionConstants.duplicateActivationCampaignSuccessClose:
					let duplicateplatforms;
					const temp2 = [];
					temp2.push(this.campaignGrid.data);
					const duperesult = temp2[0].filter((lineItem) => {
						if (lineItem.MasterCampaignUniqueIDCode === parseInt(action.value.MasterCampaignID, 10)) {
							duplicateplatforms = lineItem.AvailableActivations;
							return lineItem;
						}
					});

					const dupeplatform = duplicateplatforms.filter((lineItem) => {
						if (Number(lineItem.MasterPlatformID) === parseInt(Number(action.value.MasterPlatformID), 10)) {
							return lineItem;
						}
					});
					const dupeplatformName = dupeplatform[0].PlatformName;
					const dupeparentArray = duperesult[0].ActivationCampaigns[dupeplatformName];
					dupeparentArray.unshift(action.value);
					this.emit("advertisers_duplicated_success_close");
					break;
				case AppActionConstants.duplicateActivationCampaignSuccessOpen:
					let duplicateopenplatforms;
					const temp3 = [];
					temp3.push(this.campaignGrid.data);
					const dupeopenresult = temp3[0].filter((lineItem) => {
						if (lineItem.MasterCampaignUniqueIDCode === parseInt(action.value.MasterCampaignID, 10)) {
							duplicateopenplatforms = lineItem.AvailableActivations;
							return lineItem;
						}
					});

					const dupeopenplatform = duplicateopenplatforms.filter((lineItem) => {
						if (Number(lineItem.MasterPlatformID) === parseInt(Number(action.value.MasterPlatformID), 10)) {
							return lineItem;
						}
					});
					const dupeopenplatformName = dupeopenplatform[0].PlatformName;
					const dupeopenparentArray = dupeopenresult[0].ActivationCampaigns[dupeopenplatformName];
					dupeopenparentArray.unshift(action.value);
					this.emit("advertisers_duplicated_success_open");
					break;
				case AppActionConstants.duplicateActivationCampaignFail:
					this.campaignGrid.errors.activation = action.value;
					this.emit("advertisers_duplicated_fail");
					break;
				case AppActionConstants.editActivationDataSuccess:
					// let platforms;
					// const temp1 = [];
					// temp1.push(this.campaignGrid.data);
					// const result = temp1[0].filter((lineItem) => {
					// 	if (lineItem.MasterCampaignUniqueIDCode === parseInt(action.value.MasterCampaignID, 10)) {
					// 		platforms = lineItem.AvailableActivations;
					// 		return lineItem;
					// 	}
					// });

					/* Update ParentUniqueID for Workbook */
					this.campaignGrid.selectedParentCampaignUniqueID = action.value.CampaignID;
					this.campaignGrid.selectedMasterCampaignUniqueID = action.value.MasterCampaignID;

					// const platform = platforms.filter((lineItem) => {
					// 	if (Number(lineItem.MasterPlatformID) === parseInt(Number(action.value.MasterPlatformID), 10)) {
					// 		return lineItem;
					// 	}
					// });
					// const platformName = platform[0].PlatformName;
					// const parentArray = result[0].ActivationCampaigns[platformName];
					// parentArray.forEach((activation) => {
					// 	if (activation.CampaignUniqueCode === action.value.CampaignID) {
					// 		parentArray.splice(parentArray.indexOf(activation), 1, action.value);
					// 	}
					// });
					this.emit("edit_activation_success");
					break;
				case AppActionConstants.editActivationDataFail:
					this.campaignGrid.errors.activation = action.value;
					this.emit("edit_error_activation");
					break;
				case AppActionConstants.updateCampaignDataSuccess:
					this.campaignGrid.data = [action.value, ...this.campaignGrid.data];
					this.campaignGrid.newCampaign = action.value;
					this.emit("success_post");
					break;
				case AppActionConstants.updateCampaignDataFail:
					this.campaignGrid.errors.campaign = action.value;
					this.emit("error_post");
					break;
				case AppActionConstants.editCampaignDataSuccess:
					let index = null;
					const data = [...this.campaignGrid.data];
					data.forEach((campaign) => {
						if (campaign.MasterCampaignUniqueIDCode === action.value.MasterCampaignUniqueIDCode) {
							index = data.indexOf(campaign);
						}
					});
					data.splice(index, 1, action.value);
					this.campaignGrid.data = data;
					this.emit("success_edit");
					break;
				case AppActionConstants.editCampaignDataFail:
					this.campaignGrid.errors.campaign = action.value;
					this.emit("error_edit");
					break;
				case AppActionConstants.advertisersFetched:
					this.campaignGrid.advertiserFields = { ...this.campaignGrid.advertiserFields, ...action.value };
					this.emit("advertisers_fetched");
					break;
				case AppActionConstants.advertiserCreatedSuccess:
					this.campaignGrid.advertiserSuccess = [...this.campaignGrid.advertiserSuccess, action.advertiser];
					this.emit("advertisers_created_success");
					break;
				case AppActionConstants.advertiserCreatedBulkSuccess:
					this.campaignGrid.advertiserSuccess = [...this.campaignGrid.advertiserSuccess, ...action.advertisers];
					this.emit("advertisers_created_bulk_success");
					break;
				case AppActionConstants.advertiserCreatedFail:
					this.campaignGrid.advertiserErrors[action.advertiser] = action.value;
					this.emit("advertisers_created_fail");
					break;
				case AppActionConstants.advertiserCreatedBulkFail:
					this.campaignGrid.advertiserErrors = action.value;
					this.emit("advertisers_created_bulk_fail");
					break;
				case AppActionConstants.advertiserUpdatedSuccess:
					this.campaignGrid.editAdvertiserSuccessObj[action.advertiser] = action.value;
					this.emit("advertisers_updated_success");
					break;
				case AppActionConstants.advertiserUpdatedBulkSuccess:
					this.campaignGrid.advertiserSuccessObj = [...this.campaignGrid.advertiserSuccessObj, ...action.advertisers];
					this.emit("advertisers_updated_bulk_success");
					break;
				case AppActionConstants.advertiserUpdatedFail:
					this.campaignGrid.advertiserErrors[action.advertiser] = action.value;
					this.emit("advertisers_updated_fail");
					break;
				case AppActionConstants.advertiserUpdatedBulkFail:
					this.campaignGrid.advertiserErrors = action.value;
					this.emit("advertisers_updated_bulk_fail");
				case AppActionConstants.getPlatformAdvertisers:
					this.campaignGrid.platformAdvertisers = action.value;
					this.emit("platform_advertisers_fetched");
					break;
				case AppActionConstants.dataKeyDataValueFilters:
					this.campaignGrid.dataKeyDataValueFilters = action.value;
					this.emit("dataKeyDataValue_filters_fetched");
					break;
				case AppActionConstants.bulkArchiveCampaignSuccess:
					const changedCampaigns = [...this.campaignGrid.data];
					const checkedIDs = [];

					changedCampaigns.forEach((campaign) => {
						action?.value?.MasterCampaignID?.forEach((id) => {
							if (campaign.MasterCampaignID.toString() === id.toString() && !checkedIDs.includes(campaign.MasterCampaignID)) {
								checkedIDs.push(campaign.MasterCampaignID);
								campaign.IsArchived = true;
								Object.keys(campaign.ActivationCampaigns).forEach((platformName) => {
									const existingCampaigns = _.cloneDeep(campaign.ActivationCampaigns[platformName]);
									if (campaign.ArchivedCampaigns[platformName]) {
										existingCampaigns.forEach((existingCampaign) => {
											existingCampaign.IsArchived = "True";
											campaign.ArchivedCampaigns[platformName].push(existingCampaign);
										});
									} else {
										campaign.ArchivedCampaigns[platformName] = [];
										existingCampaigns.forEach((existingCampaign) => {
											existingCampaign.IsArchived = "True";
											campaign.ArchivedCampaigns[platformName].push(existingCampaign);
										});
									}
									setTimeout(() => {
										campaign.ActivationCampaigns[platformName] = [];
									}, 0);
								});
							}
						});
						action?.pairings?.forEach((pairing) => {
							if (campaign.MasterCampaignID.toString() === pairing[0]) {
								let archivedActivationCampaign = null;
								campaign.ActivationCampaigns[pairing[2]].forEach((activationCampaign) => {
									if (activationCampaign.CampaignID === pairing[1]) {
										archivedActivationCampaign = JSON.parse(JSON.stringify(activationCampaign));
									}
								});
								archivedActivationCampaign.IsArchived = "True";
								campaign.ActivationCampaigns[pairing[2]] = campaign.ActivationCampaigns[pairing[2]].filter((ac) => {
									return ac.CampaignID !== archivedActivationCampaign.CampaignID;
								});
								if (campaign.ArchivedCampaigns[pairing[2]]) {
									campaign.ArchivedCampaigns[pairing[2]].push(archivedActivationCampaign);
								} else {
									campaign.ArchivedCampaigns[pairing[2]] = [];
									campaign.ArchivedCampaigns[pairing[2]].push(archivedActivationCampaign);
								}
							}
						});
					});

					if (checkedIDs?.length > 0) {
						this.campaignGrid.data = changedCampaigns.filter((campaign) => {
							return !checkedIDs.includes(campaign.MasterCampaignID);
						});
					}
					if (action.actionType === "unarchive") {
						this.emit("unarchiveSuccess");
					} else {
						this.emit("archiveSuccess");
					}
					break;
				case AppActionConstants.archiveMasterCampaignSuccess:
					const archiveChangedCampaigns = [...this.campaignGrid.data];
					const checkedCampaignIDs = [];
					archiveChangedCampaigns.forEach((campaign) => {
						if (campaign.MasterCampaignID === action.value.MasterCampaignID[0] && !checkedCampaignIDs.includes(campaign.MasterCampaignID)) {
							checkedCampaignIDs.push(campaign.MasterCampaignID);
							if (action.isArchive === true) {
								campaign.IsArchived = true;
								Object.keys(campaign.ActivationCampaigns).forEach((platformName) => {
									const existingCampaigns = _.cloneDeep(campaign.ActivationCampaigns[platformName]);
									if (campaign.ArchivedCampaigns[platformName]) {
										existingCampaigns.forEach((existingCampaign) => {
											existingCampaign.IsArchived = "True";
											campaign.ArchivedCampaigns[platformName].push(existingCampaign);
										});
									} else {
										campaign.ArchivedCampaigns[platformName] = [];
										existingCampaigns.forEach((existingCampaign) => {
											existingCampaign.IsArchived = "True";
											campaign.ArchivedCampaigns[platformName].push(existingCampaign);
										});
									}
									setTimeout(() => {
										campaign.ActivationCampaigns[platformName] = [];
									}, 0);
								});
								archiveChangedCampaigns.splice(archiveChangedCampaigns.length, 0, campaign);
								archiveChangedCampaigns.splice(archiveChangedCampaigns.indexOf(campaign), 1);
							} else if (action.isArchive === false) {
								campaign.IsArchived = false;
								Object.keys(campaign.ArchivedCampaigns).forEach((platformName) => {
									const existingCampaigns = _.cloneDeep(campaign.ArchivedCampaigns[platformName]);
									if (campaign.ActivationCampaigns[platformName]) {
										existingCampaigns.forEach((existingCampaign) => {
											existingCampaign.IsArchived = "False";
											campaign.ActivationCampaigns[platformName].push(existingCampaign);
										});
									} else {
										campaign.ActivationCampaigns[platformName] = [];
										existingCampaigns.forEach((existingCampaign) => {
											existingCampaign.IsArchived = "False";
											campaign.ActivationCampaigns[platformName].push(existingCampaign);
										});
									}
									setTimeout(() => {
										campaign.ArchivedCampaigns[platformName] = [];
									}, 0);
								});
								archiveChangedCampaigns.splice(archiveChangedCampaigns.indexOf(campaign), 1);
								archiveChangedCampaigns.unshift(campaign);
							}
						}
					});
					this.campaignGrid.data = archiveChangedCampaigns;
					if (action.isArchive === true) {
						this.emit("archiveSuccess");
					} else if (action.isArchive === false) {
						this.emit("unarchiveSuccess");
					}
					break;
				case AppActionConstants.archiveActivationCampaignSuccess:
					const originalCampaigns = [...this.campaignGrid.data];
					originalCampaigns.forEach((masterCampaign) => {
						if (masterCampaign.MasterCampaignID === action.masterCampaignID) {
							if (action.isArchive === true) {
								let archivedActivationCampaign = null;
								masterCampaign.ActivationCampaigns[action.platformName].forEach((activationCampaign) => {
									if (activationCampaign.CampaignID === action.value.CampaignID[0]) {
										archivedActivationCampaign = JSON.parse(JSON.stringify(activationCampaign));
									}
								});
								archivedActivationCampaign.IsArchived = "True";
								masterCampaign.ActivationCampaigns[action.platformName] = masterCampaign.ActivationCampaigns[action.platformName].filter((ac) => {
									return ac.CampaignID !== archivedActivationCampaign.CampaignID;
								});
								if (masterCampaign.ArchivedCampaigns[action.platformName]) {
									masterCampaign.ArchivedCampaigns[action.platformName].push(archivedActivationCampaign);
								} else {
									masterCampaign.ArchivedCampaigns[action.platformName] = [];
									masterCampaign.ArchivedCampaigns[action.platformName].push(archivedActivationCampaign);
								}
							} else if (action.isArchive === false) {
								let unarchivedActivationCampaign = null;
								masterCampaign.ArchivedCampaigns[action.platformName].forEach((activationCampaign) => {
									if (activationCampaign.CampaignID === action.value.CampaignID[0]) {
										unarchivedActivationCampaign = JSON.parse(JSON.stringify(activationCampaign));
									}
								});
								unarchivedActivationCampaign.IsArchived = "False";
								masterCampaign.ArchivedCampaigns[action.platformName] = masterCampaign.ArchivedCampaigns[action.platformName].filter((ac) => {
									return ac.CampaignID !== unarchivedActivationCampaign.CampaignID;
								});
								if (masterCampaign.ActivationCampaigns[action.platformName]) {
									masterCampaign.ActivationCampaigns[action.platformName].push(unarchivedActivationCampaign);
								} else {
									masterCampaign.ActivationCampaigns[action.platformName] = [];
									masterCampaign.ActivationCampaigns[action.platformName].push(unarchivedActivationCampaign);
								}
							}
						}
					});
					this.campaignGrid.data = originalCampaigns;
					if (action.isArchive === true) {
						this.emit("archiveACSuccess");
					} else if (action.isArchive === false) {
						this.emit("unarchiveACSuccess");
					}
					break;
				case AppActionConstants.copyCampaignSuccess:
					this.campaignGrid.targetMasterCampaignID = action.masterCampaignID;
					this.campaignGrid.clonedActivationCampaign = action.activationCampaignID;
					this.campaignGrid.previousActivationCampaignIDs = action.previousActivationCampaignIDs;
					this.emit("copyCampaignSuccess");
					break;
				case AppActionConstants.draftCampaignSuccess:
					this.emit("draftCampaignSuccess");
					break;
				case AppActionConstants.draftCampaignFail:
					this.emit("draftCampaignFail");
					break;
				case AppActionConstants.setSelectedCampaigns:
					this.campaignGrid.selectedCampaigns = action.value;
					this.emit("selectedCampaignsUpdated");
					break;
				case AppActionConstants.addCampaignToPrismaSuccess:
					const PrismaExternalSystemResponse = action.value.ExternalSystemResponse;
					const PrismaExternalSystemResponse_Orig = action.value.ExternalSystemResponse_Orig;
					const PrismaExternalSystemStatusID = action.value.ExternalSystemStatusID;
					const PrismaExternalSystemStatusName = action.value.ExternalSystemStatusName;

					this.campaignGrid.data = getUpdatedCampaignDataPostPush(
						this.campaignGrid,
						{
							ExternalSystemResponse: PrismaExternalSystemResponse || "Synced",
							ExternalSystemResponse_Orig: PrismaExternalSystemResponse_Orig || "Synced",
							ExternalSystemStatusID: PrismaExternalSystemStatusID || "3",
							ExternalSystemStatusName: PrismaExternalSystemStatusName || "Synced"
						},
						action.platform
					);
					this.campaignGrid.pushedCampaign = action.value;
					this.emit("pushToPrismaSuccess");
					break;
				case AppActionConstants.addCampaignToPrismaFailure:
					this.campaignGrid.data = getUpdatedCampaignDataPostPush(
						this.campaignGrid,
						{
							ExternalSystemResponse: action?.Errors?.[0] || "Attempted Sync",
							ExternalSystemResponse_Orig: action?.Errors?.[0] || "Attempted Sync",
							ExternalSystemStatusID: "2",
							ExternalSystemStatusName: "Attempted Sync"
						},
						action.platform
					);
					this.emit("pushToPrismaFailure");
					break;
				case AppActionConstants.addCampaignToDV360Success:
					const DV360ExternalSystemResponse = action.value.ExternalSystemResponse;
					const DV360ExternalSystemResponse_Orig = action.value.ExternalSystemResponse_Orig;
					const DV360ExternalSystemStatusID = action.value.ExternalSystemStatusID;
					const DV360ExternalSystemStatusName = action.value.ExternalSystemStatusName;

					this.campaignGrid.data = getUpdatedCampaignDataPostPush(
						this.campaignGrid,
						{
							ExternalSystemResponse: DV360ExternalSystemResponse || "Synced",
							ExternalSystemResponse_Orig: DV360ExternalSystemResponse_Orig || "Synced",
							ExternalSystemStatusID: DV360ExternalSystemStatusID || "3",
							ExternalSystemStatusName: DV360ExternalSystemStatusName || "Synced"
						},
						action.platform
					);
					this.campaignGrid.pushedCampaign = action.value;
					this.emit("pushToDV360Success");
					break;
				case AppActionConstants.addCampaignToDV360Failure:
					this.campaignGrid.data = getUpdatedCampaignDataPostPush(
						this.campaignGrid,
						{
							ExternalSystemResponse: action?.Errors?.[0] || "Attempted Sync",
							ExternalSystemResponse_Orig: action?.Errors?.[0] || "Attempted Sync",
							ExternalSystemStatusID: "2",
							ExternalSystemStatusName: "Attempted Sync"
						},
						action.platform
					);
					this.emit("pushToDV360Failure");
					break;
				case AppActionConstants.addCampaignToGCM:
					this.campaignGrid.gcmSuccess = action.value;
					this.emit("campaignPushedToGCM");
					break;
				case AppActionConstants.lockUnlockCampaignBudgetSuccess:
					this.campaignGrid.data = getUpdatedCampaignDataPostPush(this.campaignGrid, { IsPrismaBudgetLocked: action.value ? "True" : "False" }, "Mediaocean (OX)/Prisma");
					break;
				default:
					break;
			}
		});
	}

	/*
	Getter function to return the current state
	*/

	getData = () => this.campaignGrid.data;
	getGridConfig = () => this.campaignGrid.config;
	getMediaChannelsPlatforms = () => this.campaignGrid.mediaChannelPlatforms;
	getAdvertisers = () => this.campaignGrid.advertisers;
	getAdvertiserFields = () => this.campaignGrid.advertiserFields;
	getNewCampaign = () => this.campaignGrid.newCampaign;
	getAdvertiserSuccess = () => this.campaignGrid.advertiserSuccess;
	getAdvertiserErrors = () => this.campaignGrid.advertiserErrors;
	getAdvertiserEditSuccess = () => this.campaignGrid.editAdvertiserSuccessObj;
	getPlatformAdvertisers = () => this.campaignGrid.platformAdvertisers;
	getDataKeyDataValueFilters = () => this.campaignGrid.dataKeyDataValueFilters;
	getTargetMasterCampaignID = () => this.campaignGrid.targetMasterCampaignID;
	getClonedActivationCampaign = () => this.campaignGrid.clonedActivationCampaign;
	getPreviousActivationCampaignIDs = () => this.campaignGrid.previousActivationCampaignIDs;
	getBriefCampaignData = () => this.campaignGrid.briefCampaignData;
	getSelectedCampaigns = () => this.campaignGrid.selectedCampaigns;
	getPushedCampaign = () => this.campaignGrid.pushedCampaign;
	getNewlyCreatedActivationCampaign = () => this.campaignGrid.newlyCreatedActivationCampaign;
	getGCMSuccess = () => this.campaignGrid.gcmSuccess;
	kickOffEvent = () => {
		// console.log('work');
		this.emit("activation_success");
	};

	// getMediaChannels = () => this.campaignGrid.mediaChannels;
	getPlatforms = () => this.campaignGrid.platforms;
	getActivationConfig = () => this.campaignGrid.activationConfig;
	getMasterCampaignUniqueID = () => {
		return this.campaignGrid.selectedMasterCampaignUniqueID; // Master Campaign Shell
	};

	getParentCampaignUniqueID = () => {
		return this.campaignGrid.selectedParentCampaignUniqueID; // Line Item ID
	};

	getBriefID = (testMasterCampaignID) => {
		const campaign = this.campaignGrid.data.find(({ MasterCampaignID }) => {
			const testID = parseInt(testMasterCampaignID);
			return MasterCampaignID === testID;
		});
		if (campaign) {
			return campaign.BriefID;
		}
	};

	getErrors = () => this.campaignGrid.errors;
	resetActivationErrors = () => {
		this.campaignGrid.errors.activation = [];
		this.emit("activation__errors__reset");
	};

	resetAdvertisersSuccess = () => {
		this.campaignGrid.advertiserSuccess = [];
	};

	resetAdvertisersErrors = () => {
		this.campaignGrid.advertiserErrors = {};
	};

	resetAdvertiserEditSuccessObj = () => {
		this.campaignGrid.editAdvertiserSuccessObj = {};
	};

	resetNewCampaign = () => {
		this.campaignGrid.newCampaign = null;
	};

	resetCampaignErrors = () => {
		this.campaignGrid.errors.campaign = [];
		this.emit("campaign__errors__reset");
	};

	resetAdvertisers = () => {
		this.campaignGrid.advertiserFields = {};
		this.emit("advertiser_fields_reset");
	};

	resetPlatformAdvertisers = () => {
		this.campaignGrid.platformAdvertisers = [];
	};

	resetSelectedCampaigns = () => {
		this.campaignGrid.selectedCampaigns = {};
		this.emit("selected_campaigns_reset");
	};

	resetClonedActivationCampaign = () => {
		this.campaignGrid.targetMasterCampaignID = null;
		this.campaignGrid.clonedActivationCampaign = null;
		this.campaignGrid.previousActivationCampaignIDs = [];
	};

	resetPushedCampaign = () => {
		this.campaignGrid.pushedCampaign = null;
	};

	resetGCMSuccess = () => {
		this.campaignGrid.gcmSuccess = false;
	};

	// Leaving this here for if we want to lock the budget in the future
	// lockPrismaBudgetIfGlobalAdvertiser = data => {
	// 	const statuses = BookFiltersStore.getSyncStatuses();
	// 	if (
	// 		statuses?.find(platform => {
	// 			return platform.MasterPlatformID == 5 && platform.IsGlobalAdvertiser == true;
	// 		})
	// 	) {
	// 		data.forEach(masterCampaign => {
	// 			masterCampaign?.ActivationCampaigns?.['Mediaocean (OX)/Prisma']?.forEach(activationCampaign => {
	// 				if (activationCampaign.ExternalSystemStatusID != '1') {
	// 					activationCampaign.IsPrismaBudgetLocked = 'True';
	// 				}
	// 			});
	// 		});
	// 	}
	// 	return data;
	// };
}

export default new CampaignsStore();
